import React, { useCallback, useEffect, useState } from 'react';
import apiClient from '../../api/client';
import { useNotification } from '../../context/NotificationContext';
import MpDailyChart, { KpiGrid, mpFmt as fmt } from '../../components/MpDailyChart';

export default function AvitoListingsOverview({ clientId }) {
  const { notify } = useNotification();
  const [summary, setSummary] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [summaryRes, listRes] = await Promise.all([
        apiClient.get('/avito/listings/summary', { params: { client_id: clientId } }),
        apiClient.get('/avito/listings/manage', { params: { client_id: clientId } }),
      ]);
      setSummary(summaryRes.data);
      setItems(listRes.data?.items || []);
    } catch (e) {
      notify(e.response?.data?.message || 'Ошибка загрузки', 'error');
    } finally {
      setLoading(false);
    }
  }, [clientId, notify]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <p className="text-[var(--wb-text-muted)]">Загрузка объявлений…</p>;

  const totals = summary?.totals || {};

  return (
    <div className="space-y-4">
      <KpiGrid items={[
        { label: 'Объявлений', value: fmt(totals.listings_count) },
        { label: 'Просмотры', value: fmt(totals.views) },
        { label: 'Контакты', value: fmt(totals.contacts) },
        { label: 'В избранное', value: fmt(totals.favorites) },
        { label: 'Конверсия', value: `${fmt(totals.conversion_pct, 1)}%` },
      ]} />

      <MpDailyChart
        data={summary?.daily || []}
        lines={[
          { key: 'views', name: 'Просмотры', color: '#4f46e5' },
          { key: 'contacts', name: 'Контакты', color: '#10b981' },
          { key: 'favorites', name: 'В избранное', color: '#f97316' },
          { key: 'conversion_pct', name: 'Конверсия, %', color: '#14b8a6', yAxisId: 'right' },
        ]}
      />

      <div className="wb-card overflow-x-auto">
        <table className="wb-data-table">
          <thead>
            <tr>
              <th>Объявление</th>
              <th>Город</th>
              <th className="wb-col-num">Просмотры</th>
              <th className="wb-col-num">Контакты</th>
            </tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.item_id}>
                <td className="font-medium">{l.title}</td>
                <td>{l.city}</td>
                <td className="wb-col-num">{fmt(l.views)}</td>
                <td className="wb-col-num">{fmt(l.contacts)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
